export enum AviationAuthority {
  Other,
  FAA, // USA
  TC, // Canada
  EASA, // Europe
  CAA, // United Kingdom
  CASA, // Australia
  CAAC, // China
  DGCA, // India
  SACAA, // South Africa
  DGAC, // Chili
  JCAA, // Switzerland
  DCA, // Malaysia
}
